import React, { useState, useRef, useCallback } from "react";

const POPUP_SIZE = 220;
const POPUP_OFFSET = 12;

const Popup = ({ trigger, content, imageUrl }) => {
  const [isHovering, setIsHovering] = useState(false);
  const [popupStyle, setPopupStyle] = useState({});
  const wrapperRef = useRef(null);

  const computePosition = useCallback(() => {
    if (!wrapperRef.current) return;
    const rect = wrapperRef.current.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    const style = {};

    // Horizontal: prefer right, fallback left, fallback centered below
    if (vw - rect.right >= POPUP_SIZE + POPUP_OFFSET) {
      style.left = `calc(100% + ${POPUP_OFFSET}px)`;
    } else if (rect.left >= POPUP_SIZE + POPUP_OFFSET) {
      style.right = `calc(100% + ${POPUP_OFFSET}px)`;
    } else {
      style.left = "50%";
      style.transform = "translateX(-50%)";
      style.top = `calc(100% + ${POPUP_OFFSET}px)`;
      setPopupStyle(style);
      return;
    }

    // Vertical: center on trigger, clamp to viewport
    const centerY = rect.top + rect.height / 2;
    if (centerY - POPUP_SIZE / 2 < 0) {
      style.top = 0;
    } else if (centerY + POPUP_SIZE / 2 > vh) {
      style.bottom = 0;
    } else {
      style.top = "50%";
      style.transform = "translateY(-50%)";
    }

    setPopupStyle(style);
  }, []);

  const handleMouseEnter = () => {
    computePosition();
    setIsHovering(true);
  };

  const openImage = (e) => {
    e.stopPropagation();
    if (imageUrl) {
      window.open(imageUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className={`popup-wrapper ${imageUrl ? "popup-wrapper--clickable" : ""}`}
      ref={wrapperRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setIsHovering(false)}
      onClick={openImage}
    >
      <div className="popup-trigger">{trigger}</div>

      {isHovering && (
        <div className="popup-box" style={popupStyle} onClick={openImage}>
          {content}
        </div>
      )}
    </div>
  );
};

export default Popup;
